import React, { ReactNode } from 'react';
import { styled } from '@mui/material';
import { ModelFilterCategory } from '@store/zustand/model-filters';
import { themePalette } from '@theme/muiTheme';
import {
  CategoryIcon,
  ChartSuccessIcon,
  CoverageIcon,
  CPUIcon,
  DocumentTextIcon,
  HierarchySquareIcon,
  Profile2UserIcon,
  SearchStatusIcon,
  ShieldTickIcon,
  TaskSquareIcon,
  TickCircleIcon,
} from '@utils/iconsDefs';

/**
 * `cpu.svg` hard-codes the success green on every path, so a `fill` prop on
 * the root would not reach them; the row grey is applied to the paths instead.
 */
const GreyCPUIcon = styled(CPUIcon)({
  '& path': { fill: themePalette.grey[900] },
});

/**
 * The 20px leading icon of each root category row, by Figma layer name: Scope
 * `category-2`, Validation status `tick-circle`, Review status
 * `search-status`, Operational status `chart-success`, Operating model
 * `hierarchy-square-2`, Outsourcing partner `profile-2user`, Assurance level
 * `shield-tick`, Coverage a clipped group asset with no vuesax name (the
 * circle with one radius it shows, drawn as `filters/coverage.svg`),
 * Applicability `cpu`, Report inclusion `document-text`, CIS-18 reference
 * `task-square`.
 *
 * Figma draws every glyph in one grey, the `#636362` that the `filters/` set,
 * `tick-circle` and `profile-2user` carry, so `search-status` (whose root fill
 * is a lighter grey) and `cpu` (green) are recoloured to match.
 */
export const CATEGORY_ICONS: Record<ModelFilterCategory, ReactNode> = {
  domains: <CategoryIcon width={20} height={20} />,
  validationStatus: <TickCircleIcon width={20} height={20} />,
  reviewStatus: (
    <SearchStatusIcon width={20} height={20} fill={themePalette.grey[900]} />
  ),
  operationalStatuses: <ChartSuccessIcon width={20} height={20} />,
  operatingModelStatuses: <HierarchySquareIcon width={20} height={20} />,
  partners: <Profile2UserIcon width={20} height={20} />,
  assurance_level: <ShieldTickIcon width={20} height={20} />,
  coverage: <CoverageIcon width={20} height={20} />,
  applicability: <GreyCPUIcon width={20} height={20} />,
  reportInclusion: <DocumentTextIcon width={20} height={20} />,
  cis: <TaskSquareIcon width={20} height={20} />,
};
